<template>
  <div v-if="isVisible" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6">
      <h2 class="text-lg font-bold mb-4">Создать спецификацию</h2>
      <form @submit.prevent="createTechMap">
        <div class="mb-4">
          <label for="name" class="block text-sm font-medium text-gray-700">Название спецификации</label>
          <input
            type="text"
            id="name"
            v-model="techMap.name"
            required
            maxlength="40"
            placeholder="Название"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
        </div>

        <div class="mb-4">
          <label for="product" class="block text-sm font-medium text-gray-700">Продукция</label>
          <v-select
            id="product"
            v-model="techMap.product_id"
            :options="products"
            :reduce="product => product"
            :filterable="false"
            label="name"
            placeholder="Начните вводить название или артикул..."
            :loading="loadingProducts"
            @search="onProductSearch"
            required
          >
            <template #no-options="{ search }">
              <span v-if="loadingProducts">Загружается...</span>
              <span v-else-if="!search || search.length < 2">Введите минимум 2 символа</span>
              <span v-else>Продукция не найдена</span>
            </template>
          </v-select>
        </div>

        <div class="mb-4">
          <label for="description" class="block text-sm font-medium text-gray-700">Описание</label>
          <textarea
            id="description"
            v-model="techMap.description"
            rows="2"
            placeholder="Описание спецификации"
            class="w-full max-h-52 min-h-[44px] px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"></textarea>
        </div>

        <div class="flex justify-end space-x-2">
          <button type="button" @click="closeModal"
                  class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500">
            Отмена
          </button>
          <button type="submit"
                  class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  :disabled="isLoading"
                  :class="{'opacity-70 cursor-not-allowed': isLoading}">
            <span v-if="isLoading">Создание...</span>
            <span v-else>Добавить</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      techMap: {
        name: '',
        product_id: null,
        description: null
      },
      products: [],
      isLoading: false,
      loadingProducts: false,
      error: null,
      productSearchTimer: null
    };
  },
  mounted() {
    this.onProductSearch('');
  },
  methods: {
    closeModal() {
      this.$emit('close');
      this.resetForm();
    },
    onProductSearch(search) {
      clearTimeout(this.productSearchTimer);
      this.productSearchTimer = setTimeout(async () => {
        this.loadingProducts = true;
        try {
          const response = await axios.post('/api/product/getProducts', {
            page: 1,
            per_page: 50,
            search: search?.trim() || ''
          });
          const d = response.data?.data;
          this.products = d?.data || [];
        } catch (error) {
          console.error('Ошибка при загрузке продукции:', error);
          this.products = [];
          if (this.$toast && typeof this.$toast.error === 'function') {
            this.$toast.error('Ошибка при загрузке списка продукции');
          }
        } finally {
          this.loadingProducts = false;
        }
      }, 350);
    },
    async createTechMap() {
      if (this.isLoading) return;

      this.isLoading = true;
      this.error = null;

      try {
        const response = await axios.post('/api/techMap/createTechMap', {
          ...this.techMap,
          product_id: this.techMap.product_id?.id || null,
        });

        if (response.data.success) {
          // Показываем уведомление об успехе
          if (this.$toast && typeof this.$toast.success === 'function') {
            this.$toast.success('Спецификация успешно создана');
          }

          this.$emit('tech-map-created');
          this.closeModal();
        } else {
          // Показываем сообщение об ошибке из ответа
          this.error = response.data.message || 'Ошибка при создании спецификации';
          if (this.$toast && typeof this.$toast.error === 'function') {
            this.$toast.error(this.error);
          }
        }
      } catch (error) {
        console.error('Ошибка при создании спецификации:', error);

        // Получаем текст ошибки из ответа или используем общее сообщение
        this.error = error.response?.data?.message || 'Ошибка при создании спецификации';

        if (this.$toast && typeof this.$toast.error === 'function') {
          this.$toast.error(this.error);
        }
      } finally {
        this.isLoading = false;
      }
    },
    resetForm() {
      this.techMap = {
        name: '',
        product_id: null,
        description: null
      };
    }
  }
};
</script>
<style>
.v-select::placeholder, .vs__search::placeholder, .vs__dropdown-toggle {
  color: oklch(0.707 0.022 261.325);
}
</style>
